import { compose, hoistStatics, lifecycle, withHandlers, withState, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BlogPost from './BlogPost';
import WithLoading from '../../../../../components/WithLoading';
import sh from '../../../../../helpers/string.helper';
import apiRoutes from '../../../../../services/api.routes';
import apiService from '../../../../../services/api.service';

const enhance = compose(
  connect(null, null),
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('searchPost', 'setSearchPost', null),
  withProps(props => ({
    time: props.item && props.item.content ? sh.getReadTime(props.item.content) : 'less than 1',
    imgSrc: props.item.image ? `${apiService.baseUrl}${apiRoutes.files}${apiRoutes.slash}${props.item.image}` : '/img/blog1.png',
  })),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading } = this.props;
      setIsLoading(false);
    },
  }),
  withHandlers({
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(BlogPost)));



// WEBPACK FOOTER //
// ./src/views/modules/blog/blogPost/simple/index.js